<template>
   <div class="">
    <input type="checkbox" :checked="data.checked" v-on:change="createVehiclesArray($event, data)" v-if="!data.accountId"/>
    <p v-if="data.accountId" style="margin-bottom: 0; font-weight: bold; font-size: 20px;">Vehicles by {{data.userId}}</p>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    createVehiclesArray: function(e, v) {
        this.$eventHub.$emit("vehicleCheck", e, v);
    }
  },
};

</script>